import api from '../api'
import { createStore } from 'vuex'

const currentUrl = window.location.href
let baseDomain = 'fitbase.io'

if (currentUrl.includes('.fitbase.team')) {
    baseDomain = 'fitbase.team'
}

if (currentUrl.includes('.dev.fitbase.team')) {
    baseDomain = 'dev.fitbase.team'
}

if (currentUrl.includes('http://demo.fitbase.local/')) {
    baseDomain = 'fitbase.local'
}

if (
    currentUrl.includes('devops')
    || currentUrl.includes('192.168')
) {
    baseDomain = 'devops.fitbase.io'
}

const getDefaultState = () => ({
    token: '',
    baseDomain: baseDomain,
    subDomain: '',
    user: {},
    reservations: [],
    finishedReservations: [],
    reservationsTab: 'active',
    contracts: [],
    services: [],
    finishedContracts: [],
    finishedServices: [],
    showPreloader: false,
    showModalPreloader: false,
    isMenuOpened: false,
    settings: {
        lk: {
            app_links: {},
            logo: null
        }
    },
    clubDocuments: null,
    documentsClubId: null,
    shopItemContractModal: false,
    shopItemServiceModal: false,
    shopPaymentModal: false,
    shopSuccessModal: false,
    shopSales: [],
    shopMainCategories: [],
    itemCancelSubscriptionModal: false,
    successModal: false,
    successMessage: '',
    shopReservationScheduleId: null,
    shopReservationModal: false,
    scheduleRegistrationResult: null,
    shopReservationBooked: false,
})

const resetAccountState = (state) => {
    const defaultState = getDefaultState()

    state.user = defaultState.user
    state.reservations = defaultState.reservations
    state.finishedReservations = defaultState.finishedReservations
    state.reservationsTab = defaultState.reservationsTab
    state.contracts = defaultState.contracts
    state.services = defaultState.services
    state.finishedContracts = defaultState.finishedContracts
    state.finishedServices = defaultState.finishedServices
    state.showPreloader = defaultState.showPreloader
    state.showModalPreloader = defaultState.showModalPreloader
    state.isMenuOpened = defaultState.isMenuOpened
    state.shopItemContractModal = defaultState.shopItemContractModal
    state.shopItemServiceModal = defaultState.shopItemServiceModal
    state.shopPaymentModal = defaultState.shopPaymentModal
    state.shopSuccessModal = defaultState.shopSuccessModal
    state.shopSales = defaultState.shopSales
    state.shopMainCategories = defaultState.shopMainCategories
    state.itemCancelSubscriptionModal = defaultState.itemCancelSubscriptionModal
    state.successModal = defaultState.successModal
    state.successMessage = defaultState.successMessage
    state.shopReservationScheduleId = defaultState.shopReservationScheduleId
    state.shopReservationModal = defaultState.shopReservationModal
    state.scheduleRegistrationResult = defaultState.scheduleRegistrationResult
    state.shopReservationBooked = defaultState.shopReservationBooked

    document.body.style.overflow = ''
}

export default createStore({
    state(){
        return getDefaultState()
    },
    getters: {
        token(state){
            return (state.token) ? state.token : ''
        },
        systemUrl(state){
            return 'https://'+ state.subDomain + '.' + state.baseDomain + '/'
        },
        showPreloader(state){
            return state.showPreloader
        },
        showModalPreloader(state){
            return state.showModalPreloader
        },
        isMenuOpened(state){
            return state.isMenuOpened
        },
        storeLinks(state){
            return (state.settings.lk) ? state.settings.lk.app_links : []
        },
        logoLinks(state){
            console.log(state.settings?.lk?.logo)
            if (state.settings?.lk?.logo === null) {
                return undefined; // не загрузились настройки - undefined
            } else {
                return (state.settings.lk.logo) ? state.settings.lk.logo : null // ссылка или null, когда загрузились
            }
        },
        userId(state){
            return (state.user) ? state.user.id : ''
        },
        userName(state){
            return (state.user) ? state.user.name : ''
        },
        userEmail(state){
            if (state.user.contacts === undefined){
                return ''
            }
            let email = '';
            state.user.contacts.forEach(function (item) {
                if (item.contact_type === 'email'){
                    email = item.contact
                }
            })

            return email
        },
        userDeposit(state){
            return (state.user.deposit_full) ? state.user.deposit_full : null
        },
        reservations(state){
            return state.reservations
        },
        finishedReservations(state){
            return state.finishedReservations
        },
        reservationsTab(state){
            return state.reservationsTab
        },
        contracts(state){
            return state.contracts
        },
        services(state){
            return state.services
        },
        items(state){
            let contracts = state.contracts;
            let services = state.services;

            return contracts.concat(services);
        },
        finishedItems(state){
            let contracts = state.finishedContracts;
            let services = state.finishedServices;

            return contracts.concat(services);
        },
        settings(state){
            return state.settings;
        },
        documentsLk(state){
            return state.documentsClubId === null ? state.settings?.lk : state.clubDocuments?.lk
        },
        documentsModules(state){
            return state.documentsClubId === null ? state.settings?.modules : state.clubDocuments?.modules
        },
        shopItemContractModal(state){
            return state.shopItemContractModal
        },
        shopItemServiceModal(state) {
            return state.shopItemServiceModal
        },
        shopPaymentModal(state){
            return state.shopPaymentModal
        },
        shopSuccessModal(state){
            return state.shopSuccessModal
        },
        shopSales(state){
            return state.shopSales
        },
        shopMainCategories(state){
            return state.shopMainCategories
        },
        itemCancelSubscriptionModal(state) {
            return state.itemCancelSubscriptionModal
        },
        successModal(state) {
            return state.successModal
        },
        successMessage(state) {
            return state.successMessage
        },
        shopReservationModal(state) {
            return state.shopReservationModal;
        },
        shopReservationScheduleId(state) {
            return state.shopReservationScheduleId;
        },
        shopReservationBooked(state) {
            return state.shopReservationBooked;
        }
    },
    mutations: {
        SHOW_PRELOADER(state){
            state.showPreloader = true
        },
        HIDE_PRELOADER(state){
            state.showPreloader = false
        },
        SHOW_MODAL_PRELOADER(state){
            state.showModalPreloader = true
        },
        HIDE_MODAL_PRELOADER(state){
            state.showModalPreloader = false
        },
        SHOW_MENU(state){
            document.body.style.overflow = 'hidden';
            state.isMenuOpened = true
        },
        HIDE_MENU(state){
            document.body.style.overflow = '';
            state.isMenuOpened = false
        },
        SET_TOKEN (state, token) {
            const normalizedToken = token || ''

            if (state.token !== normalizedToken) {
                resetAccountState(state)
            }

            state.token = normalizedToken
        },
        RESET_ACCOUNT_STATE(state) {
            resetAccountState(state)
        },
        INIT_API_PARAMS(state){
            let subDomain = document.getElementById('app')?.dataset?.domain
                || document.querySelector('lk-schedule')?.getAttribute('data-subdomain')
                || 'demo'
            if (subDomain.includes('staging.devops')){
                subDomain = 'staging'
            }

            state.token = localStorage.getItem('fitbase_token')
            state.subDomain = subDomain
        },
        SET_SETTINGS (state, data) {
            state.settings = data
        },
        SET_CLUB_DOCUMENTS (state, data) {
            state.clubDocuments = data
        },
        SET_DOCUMENTS_CLUB (state, clubId) {
            state.documentsClubId = clubId
        },
        SET_USER (state, data) {
            state.user = data
        },
        SET_RESERVATIONS (state, data) {
            state.reservations = data
        },
        SET_FINISHED_RESERVATIONS (state, data) {
            state.finishedReservations = data
        },
        SET_RESERVATIONS_TAB (state, data) {
            state.reservationsTab = data
        },
        SET_CONTRACTS (state, data) {
            state.contracts = data
        },
        SET_SERVICES (state, data) {
            state.services = data
        },
        SET_FINISHED_CONTRACTS (state, data) {
            state.finishedContracts = data
        },
        SET_FINISHED_SERVICES (state, data) {
            state.finishedServices = data
        },
        SET_SHOP_ITEM_CONTRACT_MODAL (state, data) {
            state.shopItemContractModal = data
        },
        SET_SHOP_ITEM_SERVICE_MODAL (state, data) {
            state.shopItemServiceModal = data
        },
        SET_SHOP_PAYMENT_MODAL (state, data) {
            state.shopPaymentModal = data
        },
        SET_SCHEDULE_REGISTRATION_RESULT (state, data) {
            state.scheduleRegistrationResult = data
        },
        SET_SHOP_SUCCESS_MODAL (state, data) {
            state.shopSuccessModal = data
        },
        SET_SHOP_SALES (state, data) {
            state.shopSales = data
        },
        SET_SHOP_MAIN_CATEGORIES (state, data) {
            state.shopMainCategories = data
        },
        SET_ITEM_CANCEL_SUBSCRIPTION_MODAL(state, data) {
            state.itemCancelSubscriptionModal = data
        },
        SHOW_SUCCESS_MODAL(state, message) {
            state.successModal = true;
            state.successMessage = message;
        },
        HIDE_SUCCESS_MODAL(state) {
            state.successModal = false;
            state.successMessage = '';
        },
        SET_SHOP_RESERVATION(state, scheduleId) {
            state.shopReservationScheduleId = scheduleId;
            state.shopReservationModal = Boolean(scheduleId);
        },
        SET_SHOP_RESERVATION_MODAL(state, value) {
            state.shopReservationModal = value;
            if (!value) {
                state.shopReservationScheduleId = null;
                state.shopReservationBooked = false;
            }
        },
        SET_SHOP_RESERVATION_BOOKED(state, value) {
            state.shopReservationBooked = value;
        }
    },
    actions: {
        async loadSettings(){
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const clubId = urlParams.get('c');
                const params = clubId ? { c: clubId } : {};

                const data = (await api.settings.settings(params)).data;

                this.commit('SET_SETTINGS', data)
            }catch (e) {
                console.log(e)
            }
        },
        async loadClubDocuments({ commit, state }, clubId){
            commit('SET_DOCUMENTS_CLUB', clubId)
            commit('SET_CLUB_DOCUMENTS', null)
            try {
                const data = (await api.settings.documents(clubId)).data
                if (state.documentsClubId === clubId) {
                    commit('SET_CLUB_DOCUMENTS', {
                        lk: { email: data.email, legal_entity: data.legal_entity },
                        modules: data.modules
                    })
                }
            } catch (e) {
                console.error(e)
            }
        },
        resetClubDocuments({ commit }){
            commit('SET_DOCUMENTS_CLUB', null)
            commit('SET_CLUB_DOCUMENTS', null)
        },
        async loadUser(){
            try {
                this.commit('SHOW_PRELOADER')

                const user = (await api.user.getUser()).data;

                if (user[0] === null){
                    localStorage.removeItem('fitbase_token')
                    location.reload()
                }

                this.commit('SET_USER', user)

                this.commit('HIDE_PRELOADER')
            }catch (e) {
                if (e.response.status === 401 || e.response.status === 400){
                    localStorage.removeItem('fitbase_token')
                    location.reload()
                }
            }
        },
        async loadReservations(){
            const reservations = (await api.schedule.getReservations({
                params: {
                    available: 1,
                 //   active_records: 1,
                    pageSize: -1
                }
            })).data;
            this.commit('SET_RESERVATIONS', reservations)
        },
        async loadFinishedReservations(){
            const reservations = (await api.schedule.getReservations({
                params: {
                    expired: 1,
                    pageSize: -1
                }
            })).data;
            this.commit('SET_FINISHED_RESERVATIONS', reservations)
        },
        async loadContracts(){
            const contracts = (await api.contract.getContracts({
                params: {
                    pageSize: -1
                }
            })).data;
            this.commit('SET_CONTRACTS', contracts)
        },
        async loadServices(){
            const services = (await api.service.getServices({
                params: {
                    pageSize: -1
                }
            })).data;
            this.commit('SET_SERVICES', services)
        },
        async loadHomeData() {
            await Promise.all([
                this.dispatch('loadReservations'),
                this.dispatch('loadContracts'),
                this.dispatch('loadServices')
            ])
        },
        async loadFinishedContracts(){
            const contracts = (await api.contract.getContracts({
                params: {
                    closed: 1,
                    pageSize: -1
                }
            })).data;
            this.commit('SET_FINISHED_CONTRACTS', contracts)
        },
        async loadFinishedServices(){
            const services = (await api.service.getServices({
                params: {
                    closed: 1,
                    pageSize: -1
                }
            })).data;
            this.commit('SET_FINISHED_SERVICES', services)
        },
        async loadShopSales({ commit }, scheduleId = null) {
            const sales = (await api.shop.getSales({
                params: {
                    schedule_id: scheduleId
                }
            })).data.items;
            commit('SET_SHOP_SALES', sales);
        },
        async loadShopMainCategories({ commit }, scheduleId = null) {
            const categories = (await api.shop.getCategories({
                params: {
                    schedule_id: scheduleId
                }
            })).data.items;
            commit('SET_SHOP_MAIN_CATEGORIES', categories);
        },
        closeModals(){
            this.commit('SET_SHOP_PAYMENT_MODAL', false)
            this.commit('SET_SHOP_SUCCESS_MODAL', false)
            this.commit('SET_SHOP_ITEM_CONTRACT_MODAL', false)
            this.commit('SET_SHOP_ITEM_SERVICE_MODAL', false)
            this.commit('SET_ITEM_CANCEL_SUBSCRIPTION_MODAL', false)
        },
        async optionsClub() {
            console.log(api.optionsClub);
            const clubs = await api.user.optionsClub();
            return clubs;
        }
    }
})
